import { Stack } from '@mantine/core';
import type { UseFormReturn } from 'react-hook-form';
import type { FormNames } from '../../../../../react-commons/utils/form/getFormNames';
import { ResourceType } from '../../../resource/enumerations/ResourceType';
import {
    ContentPropertyValidation,
    type ContentResource,
} from '../../../resource/resources/artifacts/content/contentResource';
import { Form_RoleFieldArray } from '../../reusable-components/base/property-bases/Form_RoleFieldArray';
import { PropertyInputs } from '../../reusable-components/base/property-bases/PropertyInputs';
import type { PropertyValidationInformation } from '../../util/PropertyValidationInformation';

export const ContentContent = ({
    id,
    versionId,
    form,
    formNames,
    readOnly,
}: {
    id?: string;
    versionId?: string;
    form: UseFormReturn<ContentResource>;
    formNames: FormNames<ContentResource>;
    readOnly: boolean;
}) => {
    const getPropertyValidationInformation = (
        propertyIdentifier: ContentPropertyValidation
    ): PropertyValidationInformation => ({
        resourceId: id,
        resourceType: ResourceType.CONTENT,
        propertyIdentifier,
    });

    return (
        <Stack>
            <PropertyInputs.Name
                name={formNames.name}
                control={form.control}
                readOnly={readOnly}
                propertyValidationInformation={getPropertyValidationInformation(ContentPropertyValidation.NAME)}
            />
            <Form_RoleFieldArray
                form={form}
                readOnly={readOnly}
                name={formNames.relevantRoles}
                label={'Relevant Roles'}
                versionedIn={versionId ?? ''}
            />
        </Stack>
    );
};
